.isReadOnly > div > div > div > div {
	border-color: transparent !important;
}
